import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query/react";
import rootReducer from "./reducers";
import loginApi from "./apis/login";
import masterDataApi from "./apis/get-master-data";
import { jpmsApi } from "./apis/jpms";
import {questionnaireApi} from "./apis/questionnaire";
import verifyServiceAPI from "./apis/verify-service";
import folderManagementApi from "./apis/folder-management";
import jobposting from "./apis/job-posting";
export const reduxMiddlewares = [
      // add middlewares here ...
      loginApi.middleware,
      masterDataApi.middleware,
      jpmsApi.middleware,
      questionnaireApi.middleware,
      verifyServiceAPI.middleware,
      folderManagementApi.middleware,
      jobposting.middleware,
  ]

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware: any) => {
    // Get the default middleware from RTK
    const defaultMiddleware = getDefaultMiddleware({
      serializableCheck: false,
    });

    // Combine RTK Query middleware and Redux middlewares
    const allMiddleware = [...defaultMiddleware, ...reduxMiddlewares];

    return allMiddleware;
  },
});

export default store;

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;

export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

// Pass only the dispatch function to setupListeners
setupListeners(store.dispatch);
